<script>
  import { createEventDispatcher } from 'svelte';
  import { Dropdown } from 'bootstrap';
  const dispatch = createEventDispatcher();
  import { onMount, getContext, setContext, onDestroy } from 'svelte';

  export let showTitle = true;
  export let showIcon = false;
  export let title;
  export let option = [];
  export let active;
  export let titleStyle;
  export let titleClass;
  export let deleteSelected = true;
  export let checkbox;
  export let searchbox = false;
  export let Style;
  export let dropDownStyle;
  export let selectable;
  export let titleChanged = false;
  export let removeIcon = false;
  export let checkedFields = '';
  export let selectAllChecked = false;
  let btnDropdown;
  export let defaultTitle = title != undefined ? title.toString() : '';

  export let labelFields = 'name';
  export let keyFields = 'id';
  export let icon = '';
  export let extraClass = '';

  const forceCloseDropdown = (event) => {
    if (event) {
      const dropDownButton = event.target.closest('.dropdown')?.querySelector('.dropdown-toggle');
      if (dropDownButton) {
        Dropdown.getInstance(dropDownButton).hide();
      }
    }
  };

  function onItemSelect(item, event) {
    if (titleChanged) {
      setTimeout(() => {
        if (item[labelFields] != undefined) {
          title = item[labelFields];
        } else if (item.name != undefined) {
          title = item.name;
        } else {
          title = item.text;
        }
        icon = item.icon;
        if (item.extraClass) {
          extraClass = item.extraClass;
        }
      }, 100);
    }
    dispatch('onSelect', item);

    searchKeyword = '';
    if (!checkbox && event) {
      forceCloseDropdown(event);
    }
  }
  let selectedCheckbox = [];

  let checkedOne = false;
  const checkBoxCount = () => {
    if (checkbox && checkedFields != undefined) {
      try {
        let options = option.filter((item, key) => {
          item.checkboxKey = key;
          return item[checkedFields] == true;
        });
        selectedCheckbox = options;
      } catch (err) {}
    }
  };
  export const resetSelectBox = () => {
    title = defaultTitle;
  };

  $: option && checkBoxCount();

  onMount(() => {
    checkBoxCount();
    btnDropdown.parentNode.addEventListener(
      'show.bs.dropdown',
      function (event) {
        showFocusOnSearchBox();
      },
      false,
    );
  });

  import { searchKeyByValue } from 'components/Helper.js';
  let searchKeyword = '';
  export let show = false;
  export let showConfirm = false;
  const showDialog = getContext('showDialog');
  const showOverlay = getContext('showOverlay');
  const hideOverlay = getContext('hideOverlay');
  export let confirmMessage = 'Are you sure?';
  let dropdownClickTime;
  document.onclick = function (e) {
    if (
      dropdownClickTime != undefined &&
      new Date().getTime() - dropdownClickTime.getTime() > 500
    ) {
      if (e.target.closest('.dropdown-menu') == null && show) {
        show = false;
      }
    }
  };
  let inputSearchbox;
  const showFocusOnSearchBox = () => {
    if (searchbox) {
      setTimeout(() => {
        inputSearchbox.focus();
      }, 100);
    }
  };
  let extraId = Math.random();
  export let dropdownId = 'dropdownMenuButton';
</script>

<div
  class="{Style}  dropdown btn-drop-down position-relative inputSearchbox {title != defaultTitle
    ? 'active'
    : ''} {title != defaultTitle ? 'active' : ''} me-1"
>
  <button
    on:click={() => {
      if (checkbox) {
        if (showConfirm && show == false) {
          showDialog({
            type: 'confirm',
            title: '',
            message: confirmMessage,
            okFunc: () => {
              show = true;
            },
          });
        } else {
          show = !show;
          dropdownClickTime = new Date();
          if (show) {
            showOverlay({
              onHide: () => {
                show = false;
              },
            });
          }
        }
      }
      showFocusOnSearchBox();
    }}
    class=" btn h-100 dropdown-toggle mb-0 bg-transparent shadow-none border-0 {extraClass
      ? extraClass
      : ''} {showIcon && icon != '' ? 'd-flex flex-row align-items-center' : ''}  {show
      ? 'showDropDown'
      : ''} {checkbox && selectedCheckbox.length > 0 ? 'active' : null} "
    type="button"
    bind:this={btnDropdown}
    id={dropdownId}
    data-bs-toggle={checkbox ? '' : 'dropdown'}
    aria-haspopup="false"
    aria-expanded="false"
    style="min-height:34px;"
  >
    {#if showIcon && icon != ''}
      <div>
        <img
          alt=""
          class="icon-16"
          src="/images/{icon}"
        />
      </div>
    {/if}
    {#if showTitle}
      <span
        style={titleStyle}
        class="title {titleClass || ''}">{title}</span
      >
    {/if}
    {#if selectedCheckbox.length > 0}
      <span class="select-counter color-blue">{selectedCheckbox.length}</span>
    {/if}
  </button>
  {#if title != defaultTitle && titleChanged && deleteSelected}
    <button
      class="remove-btn bg-transparent border-0"
      on:click={() => {
        title = defaultTitle;
        dispatch('onSelect', '');
      }}
    >
      <img
        alt=""
        src="/images/close.svg"
      />
    </button>
  {/if}
  {#if removeIcon && selectedCheckbox.length > 0}
    <button
      class="remove-btn bg-transparent border-0"
      on:click={() => {
        title = defaultTitle;
        selectAllChecked = false;
        option = option.map((item) => {
          item[checkedFields] = false;

          return item;
        });
        dispatch('onClear', '');
      }}
    >
      <img
        alt=""
        src="/images/close.svg"
      />
    </button>
  {/if}
  <div
    class="dropdown-menu d-flex flex-column {dropDownStyle} {show ? 'show' : ''}"
    aria-labelledby={dropdownId}
  >
    {#if searchbox == true}
      <div class="search-keyword px-2">
        <input
          class="form-control"
          bind:this={inputSearchbox}
          placeholder="Search..."
          type="text"
          on:keyup={(e) => {
            selectedCheckbox = [];
          }}
          bind:value={searchKeyword}
        />
      </div>
    {/if}
    <div class="select-checkbox">
      {#if checkbox == true && checkedFields != '' && (title == 'Assignee' || title == 'Client' || title == 'User')}
        <div class="position-relative">
          <div class="checkbox c-checkbox px-2 mb-1">
            <label class="font-size-12 checkbox-label d-flex flex-row align-items-center">
              <input
                type="checkbox"
                checked={selectAllChecked}
                on:change={(event) => {
                  selectAllChecked = event.target.checked;
                  option = option.map((item) => {
                    let keyword = item[labelFields];
                    if (
                      searchKeyword == '' ||
                      keyword.toLowerCase().indexOf(searchKeyword.toLowerCase()) != -1
                    ) {
                      item[checkedFields] = event.target.checked;
                    }
                    return item;
                  });
                }}
              />
              <span class="check-img check-box-area" />
              <p class="m-0">Select All</p>
            </label>
          </div>
        </div>
      {/if}
      {#each option.filter((item) => {
        let keyword = item[labelFields];
        return searchKeyword == '' || keyword
            .toLowerCase()
            .indexOf(searchKeyword.toLowerCase()) != -1;
      }) as item, key}
        {#if checkbox == true}
          <div class="position-relative">
            <div class="checkbox c-checkbox px-2 mb-1">
              <label class="font-size-12 checkbox-label d-flex flex-row align-items-center">
                <input
                  type="checkbox"
                  name="Change_Assign"
                  checked={checkedFields != undefined && item[checkedFields] ? true : false}
                  on:change={(event) => {
                    let oldSelectedCheckbox = selectedCheckbox;
                    if (event.target.checked) {
                      item.checkboxKey = key;
                      item[checkedFields] = true;
                      oldSelectedCheckbox.push(item);
                    } else {
                      item[checkedFields] = false;
                      oldSelectedCheckbox.splice(
                        searchKeyByValue(selectedCheckbox, 'checkboxKey', item.checkboxKey),
                        1,
                      );
                    }
                    selectedCheckbox = oldSelectedCheckbox;
                  }}
                />
                <span class="check-img check-box-area" />
                <p class="m-0 d-flex flex-row align-items-center">
                  {#if showIcon}
                    <div>
                      <img
                        alt=""
                        class="icon-16"
                        src="/images/{item.icon}"
                      />
                    </div>
                  {/if}
                  {#if item[labelFields] != undefined}
                    {item[labelFields]}
                  {:else if item.name != undefined}
                    {item.name}
                  {:else}
                    {item.text}
                  {/if}
                </p>
              </label>
            </div>
          </div>
        {:else}
          <button
            type="button"
            class="btn-link {showIcon
              ? 'd-flex flex-row align-items-center'
              : ''} btn-dropdown bg-transparent text-start color-black btn shadow-none border-0 btn-select w-100 font-size-12 py-1 text-break"
            on:click={(ev) => onItemSelect(item, ev)}
          >
            {#if showIcon}
              <div>
                <img
                  alt=""
                  class="icon-16"
                  src="/images/{item.icon}"
                />
              </div>
            {/if}
            {#if item.modalId != undefined && item.modalId != null}
              <span
                class="font-size-12 bg-transparent"
                data-bs-toggle="modal"
                data-bs-target={item.modalId}
                ><span class="text-break d-block">{item.text}</span></span
              >
            {:else if selectable}
              {#if item[labelFields] != undefined}
                {item[labelFields]}
              {:else if item.name != undefined}
                {item.name}
              {:else}
                {item.text}
              {/if}
            {:else}
              <span
                class=" font-size-12"
                href="#"
              >
                <span class="text-break d-block">
                  {#if item[labelFields] != undefined}
                    {item[labelFields]}
                  {:else if item.name != undefined}
                    {item.name}
                  {:else}
                    {item.text}
                  {/if}
                </span>
              </span>
            {/if}
          </button>
        {/if}
      {/each}
    </div>
    {#if checkbox == true}
      <div class="drop-down-footer text-center font-size-12 pt-1 border-top mt-1">
        <button
          class="btn dropdown-action-link bg-transparent shadow-none border-0 bg-transparent p-0 w-100 color-blue font-weight-500"
          on:click={() => {
            dispatch('onSelect', selectedCheckbox);
            show = false;
            searchKeyword = '';
            hideOverlay();
          }}>Apply</button
        >
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .btn-drop-down {
    .dropdown-menu {
      min-width: 240px;
    }
    &:hover {
      .remove-btn {
        display: block !important;
      }
    }
    border-radius: 4px;
    .checkbox {
      label {
        font-weight: 400;
      }
    }
    .select-counter {
      // border-left: 1px solid $silver-color;
      padding: 0px 2px;
      margin-left: 3px;
      min-width: 20px;
      display: inline-block;
    }
    .search-keyword {
      margin-bottom: 6px;
      input {
        width: 100%;
        height: 28px;
      }
    }
    .select-checkbox {
      max-height: 220px;
      overflow-y: auto;
    }
    .remove-btn {
      /*display: none;*/
      position: absolute;
      right: -3px;
      top: -4px;
      width: 17px;
      background: $lead-color !important;
      width: 16px;
      height: 16px !important;
      border-radius: 6px !important;
      line-height: 0px;
      padding: 0px;
      z-index: 1;

      img {
        width: 8px;
      }
      &:hover {
        background: $black-color !important;
      }
    }
    .active {
      background: rgba($input-border-color, 0.4) !important;
    }
    button {
      &.show {
        background: rgba($input-border-color, 0.6) !important;
      }
    }
    .checkbox-label {
      word-break: break-word;
    }
  }
  .check-box-area {
    flex: 0 0 20px;
  }
  .risk-rank-dropdown .dropdown-menu,
  .priority-dropdown .dropdown-menu {
    min-width: 100px !important;
  }
  .select-block.priority-dropdown .dropdown-toggle.high-priority,
  .select-block.priority-dropdown-template .dropdown-toggle.high-priority {
    background-color: #7030a0 !important;
    color: #fff !important;
  }
  .select-block.risk-rank-dropdown .dropdown-toggle.high-risk-rank {
    background-color: #a03064 !important;
    color: #fff !important;
  }
  .select-block.priority-dropdown .dropdown-toggle.high-priority.dropdown-toggle::after {
    background-image: url('/images/priority-highest-arrow.svg');
  }
  .client-status-dropdown button.dropdown-toggle {
    background-color: #7030a0 !important;
    color: #fff !important;
    min-height: 28px !important;
    padding-top: 0;
    padding-bottom: 0;
  }
  .select-block.client-status-dropdown .dropdown-toggle::after {
    background-image: url('/images/priority-highest-arrow.svg');
  }
</style>
